import { PAYMENT_ROUTE_NAME } from '@/libs/route-name';

export const paymentRoute = () => {
    return {
        name: PAYMENT_ROUTE_NAME.PAYMENT,
        path: 'payment',
        component: () => import('@/pages/payment/index.vue'),
    };
};
